import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

export default function AdminCustomers() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/customers");
        setRows(data);
      } catch (e) { toast.error(errMsg(e, "Load failed")); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="mx-auto max-w-5xl">
      <div>
        <span className="kbd-eyebrow">Admin</span>
        <h1 className="mt-3 font-serif-display text-3xl font-semibold text-secondary">Customers</h1>
      </div>

      <div className="mt-8 overflow-hidden rounded-2xl border border-border/70 bg-card" data-testid="admin-customers-table">
        <table className="w-full text-sm">
          <thead className="border-b border-border/70 bg-muted/50 text-left text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
            <tr>
              <th className="px-4 py-3">Created</th>
              <th className="px-4 py-3">Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Mobile</th>
              <th className="px-4 py-3">WhatsApp</th>
              <th className="px-4 py-3">Active</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={6} className="px-4 py-6 text-center text-muted-foreground">Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground" data-testid="admin-customers-empty">No customer accounts yet.</td></tr>}
            {rows.map((c) => (
              <tr key={c.id} data-testid={`admin-customer-row-${c.id}`} className="border-b border-border/60 last:border-none">
                <td className="px-4 py-3 text-xs text-muted-foreground">{(c.created_at || "").slice(0, 16).replace("T", " ")}</td>
                <td className="px-4 py-3 font-medium text-secondary">{c.name}</td>
                <td className="px-4 py-3">{c.email}</td>
                <td className="px-4 py-3">{c.mobile}</td>
                <td className="px-4 py-3">{c.whatsapp || "—"}</td>
                <td className="px-4 py-3">{c.active === false ? "no" : "yes"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
